import { createFocusTrap } from 'focus-trap';
import { breakpoints, debounce, lockScroll, unlockScroll } from '../utils';

let focusTrap = null;

const prepareSkipMenu = () => {
    $('#skipmenu').on('focus', function() {
		$(this).css('height', 'auto');
	}).on('blur', function() {
		$(this).css('height', '');
	}).on('keydown', function(e) {
		if (e.keyCode !== 13) return;
		$('#contentArea').find('.hidden-aria-target').trigger('focus');
		e.stopPropagation();
	});
};

const addCarets = () => {

    $('[data-header-submenu-parent]').each(function() {
        const $parent = $(this);
        const $link = $parent.children('a').first();
        const label = $link.html();
        const icon = $('[data-icon-caret-svg]').html();

        $link.html(`
            <span>${label}</span>
            ${icon}
        `);
    });
};

const setBodyPadding = () => {
    const headerHeight = $('[data-header]').outerHeight();

    $('body').css({ paddingTop: headerHeight });
};

const makeSticky = () => {
    const minScroll = 5;
    let didScroll = false;
    let lastScrollTop = 0;

    const adjustNavVisibilityWithScroll = (scrollTop) => {
        if (scrollTop === undefined) {
            scrollTop = $(window).scrollTop();
        }
        const $headerWrap = $('[data-header-wrap]');

        if (scrollTop > lastScrollTop) {
            if (scrollTop <= $headerWrap.outerHeight()) return;
            closeSearch();
            $headerWrap.css('margin-top', -1 * $headerWrap.outerHeight() + 'px');
        }
        else {
            if(scrollTop + $(window).height() >= $(document).height()) return;
            $headerWrap.css('margin-top', 0);
        }
    };

    setBodyPadding();

    setInterval(() => {
        if (!didScroll) return;
        let scrollTop = $(window).scrollTop();
        if (Math.abs(lastScrollTop - scrollTop) <= minScroll) return;
        adjustNavVisibilityWithScroll(scrollTop);
        lastScrollTop = scrollTop;
        didScroll = false;
    }, 250);

    $(window).scroll(
        debounce(
            (event) => didScroll = true,
            50
        )
    );

    $(window).resize(
        debounce(
            () => {
                adjustNavVisibilityWithScroll();
            },
            50
        )
    );
};

const openDropdown = ($submenuParent) => {
    if ($submenuParent.length === 0) return;

    const $submenu = $submenuParent.find('[data-header-submenu]');

    $submenuParent.attr('data-active', 1);

    gsap.fromTo(
        $submenu,
        {
            display: 'none',
            opacity: 0,
            yPercent: -100,
        },
        {
            display: 'block',
            opacity: 1,
            yPercent: 0,
            ease: 'none',
            duration: 0.2,
        }
    );
};

const closeDropdown = ($submenuParent) => {
    if ($submenuParent.length === 0) return;

    const $submenu = $submenuParent.find('[data-header-submenu]');

    $submenuParent.attr('data-active', 0);
    $submenuParent.attr('data-opened-with-click', 0);

    gsap.to(
        $submenu,
        {
            display: 'none',
            opacity: 0,
            yPercent: -100,
            ease: 'none',
            duration: 0.3,
        }
    );
};

const openMobileMenu = () => {
    const $toggle = $('[data-header-mobile-toggle]');
    const $clickout = $('[data-header-mobile-clickout]');
    const $menu = $('[data-header-mobile-menu]');
    const $header = $('[data-header]');

    $toggle.attr('data-active', 1);

    lockScroll();

    focusTrap.activate();

    $menu.css(
        'max-height',
        $(window).outerHeight() - $header.outerHeight()
    );

    gsap.fromTo(
        $clickout,
        {
            display: 'none',
            opacity: 0,
        },
        {
            display: 'block',
            opacity: 1,
            ease: 'none',
            duration: 0.3,
        }
    )

    gsap.fromTo(
        $menu,
        {
            display: 'none',
            opacity: 0,
            yPercent: -100,
        },
        {
            display: 'block',
            opacity: 1,
            yPercent: 0,
            ease: 'none',
            duration: 0.3,
        }
    );
};

const closeMobileMenu = () => {
    const $toggle = $('[data-header-mobile-toggle]');
    const $clickout = $('[data-header-mobile-clickout]');
    const $menu = $('[data-header-mobile-menu]');
    const $activeSubmenuParent = $('[data-header-submenu-parent][data-active="1"]');

    if ($activeSubmenuParent.length > 0) {
        closeMobileSubmenu($activeSubmenuParent);
    }

    $toggle.attr('data-active', 0);

    unlockScroll();

    focusTrap.deactivate();

    $menu.css('max-height', '');

    gsap.to(
        $clickout,
        {
            display: 'none',
            opacity: 0,
            ease: 'none',
            duration: 0.3,
        }
    );

    gsap.to(
        $menu,
        {
            display: 'none',
            opacity: 0,
            yPercent: -100,
            ease: 'none',
            duration: 0.3,
        }
    );
};

const toggleMobileMenu = () => {
    const $toggle = $('[data-header-mobile-toggle]');
    const isActive = $toggle.attr('data-active') == 1;

    if (!isActive) {
        openMobileMenu();
    } else {
        closeMobileMenu();
    }
};

const openMobileSubmenu = ($submenuParent) => {
    const $submenu = $submenuParent.find('[data-header-submenu]');
    const $activeSubmenuParent = $('[data-header-submenu-parent][data-active="1"]');

    if ($activeSubmenuParent.length > 0) {
        closeMobileSubmenu($activeSubmenuParent);
    }

    $submenuParent.attr('data-active', 1);

    gsap.set(
        $submenu,
        {
            display: 'block',
        }
    );

    gsap.fromTo(
        $submenu,
        {
            opacity: 0,
            height: 0,
        },
        {
            opacity: 1,
            height: 'auto',
            ease: 'none',
            duration: 0.3,
        }
    );
};

const closeMobileSubmenu = ($submenuParent) => {
    const $submenu = $submenuParent.find('[data-header-submenu]');

    $submenuParent.attr('data-active', 0);

    gsap.to(
        $submenu,
        {
            opacity: 0,
            height: 0,
            onComplete: () => {
                gsap.set(
                    $submenu,
                    {
                        display: 'none',
                    }
                );
            },
        }
    );
};

const toggleSearch = () => {
    const $toggle = $('[data-header-search-toggle]');
    const isActive = $toggle.attr('data-active') == 1;

    if (!isActive) {
        openSearch();
    } else {
        closeSearch();
    }
};

const openSearch = () => {
    if ($(window).outerWidth() < breakpoints.lg) return;

    const $toggle = $('[data-header-search-toggle]');
    const $form = $('[data-header-search-form]');

    $toggle.attr('data-active', 1);

    gsap.fromTo(
        $form,
        {
            opacity: 0,
        },
        {
            display: 'flex',
            opacity: 1,
            ease: 'none',
            duration: 0.3,
        }
    )
};

const closeSearch = () => {
    if ($(window).outerWidth() < breakpoints.lg) return;

    const $toggle = $('[data-header-search-toggle]');
    const $form = $('[data-header-search-form]');

    $toggle.attr('data-active', 0);

    gsap.to(
        $form,
        {
            display: 'none',
            opacity: 0,
            ease: 'none',
            duration: 0.3,
        }
    );
};

const adjustMenuForDesktop = () => {
    $('[data-header-mobile-toggle]').removeAttr('data-active');
    $('[data-header-submenu]').removeAttr('data-active');

    gsap.set(
        $('[data-header-mobile-clickout]'),
        {
            clearProps: 'all',
        }
    );
    gsap.set(
        $('[data-header-submenu]'),
        {
            clearProps: 'all',
        }
    );
    gsap.set(
        $('[data-header-mobile-menu]'),
        {
            display: 'flex',
            opacity: 1,
            yPercent: 0,
        }
    );
};

const adjustMenuForMobile = () => {
    $('[data-header-mobile-toggle]').attr('data-active', 0);
    $('[data-header-submenu-parent]').attr('data-active', 0);
    $('[data-header-search-toggle]').attr('data-active', 0);

    gsap.set(
        $('[data-header-mobile-clickout]'),
        {
            display: 'none',
        }
    );
    gsap.set(
        $('[data-header-submenu]'),
        {
            clearProps: 'all',
        }
    );
    gsap.set(
        $('[data-header-mobile-menu]'),
        {
            display: 'none',
        }
    );
    gsap.set(
        $('[data-header-search-form]'),
        {
            clearProps: 'all',
        }
    );
};

const registerDesktopMenuListeners = () => {

    const enterDelay = 300;
    const exitDelay = 600;
    let submenuEnterTimer = null;
    let submenuExitTimer = null;

    const $submenuParent = $('[data-header-submenu-parent]');
    const $searchToggle = $('[data-header-search-toggle]');
    const $searchForm = $('[data-header-search-form]');

    const anySubmenusOpenedWithClick = () => (
        $('[data-header-submenu-parent][data-opened-with-click="1"]').length > 0
    );

    $submenuParent.mouseenter(function() {
        const $activeSubmenuParent = (
            $('[data-header-submenu-parent][data-active="1"]')
        );
        clearTimeout(submenuExitTimer);
        if ($activeSubmenuParent.is($(this))) {
            return;
        }
        closeDropdown($activeSubmenuParent);
        submenuEnterTimer = (
            setTimeout(
                () => openDropdown($(this)),
                enterDelay
            )
        );
    });

    $submenuParent.mouseleave(function() {
        if (anySubmenusOpenedWithClick()) {
            return;
        }
        clearTimeout(submenuEnterTimer);
        submenuExitTimer = (
            setTimeout(
                () => closeDropdown($(this)),
                exitDelay
            )
        );
    });

    $submenuParent.click(function() {

        if (!$(this).is('[data-active]')) {
            openDropdown($(this));
        } else if ($(this).is('[data-opened-with-click="1"]')) {
            $(this).removeAttr('data-opened-with-click');
            closeDropdown($(this));
            return;
        }

        $(this).attr('data-opened-with-click', 1);

        const handleClickOut = (event) => {
            if (!event.originalEvent.composedPath().includes($(this).get(0))) {
                closeDropdown($(this));
                $(this).attr('data-opened-with-click', 0);
                $(document).off('click', handleClickOut);
            }
        };

        $(document).click(handleClickOut);
    });

    $searchToggle.click(function() {

        toggleSearch();

        const handleClickOut = (event) => {
            if (!event.originalEvent.composedPath().includes($(this).get(0))) {
                closeSearch();
                $(document).off('click', handleClickOut);
            }
        };

        $(document).click(handleClickOut);
    });

    $searchForm.click((event) => event.stopPropagation());
};

const deregisterDesktopMenuListeners = () => {
    const $submenuParent = $('[data-header-submenu-parent]');
    const $searchToggle = $('[data-header-search-toggle]');

    $submenuParent.off('mouseenter mouseleave click');
    $searchToggle.off('click');
    $(document).off('click');
};

const registerMobileMenuListeners = () => {
    const $toggle = $('[data-header-mobile-toggle]');
    const $clickout = $('[data-header-mobile-clickout]');
    const $submenuParent = $('[data-header-submenu-parent]');

    focusTrap = (
        createFocusTrap(
            '[data-header]',
            { initialFocus: false }
        )
    );

    $toggle.click(() => toggleMobileMenu());
    $clickout.click(() => closeMobileMenu());

    $submenuParent.click(function() {
        const $submenu = $(this).find('[data-header-submenu]');
        const isActive = $(this).attr('data-active') == 1;

        if (!isActive) {
            openMobileSubmenu($(this));
        } else {
            closeMobileSubmenu($(this));
        }
    });
};

const deregisterMobileMenuListeners = () => {
    const $toggle = $('[data-header-mobile-toggle]');
    const $clickout = $('[data-header-mobile-clickout]');
    const $submenuParent = $('[data-header-submenu-parent]');

    $toggle.off('click');
    $clickout.off('click');
    $submenuParent.off('click');
};

const prepareMenu = () => {

    deregisterDesktopMenuListeners();
    deregisterMobileMenuListeners();

    if ($(window).outerWidth() >= breakpoints.lg) {
        adjustMenuForDesktop();
        registerDesktopMenuListeners();
    } else {
        adjustMenuForMobile();
        registerMobileMenuListeners();
    }
};

const initialize = () => {

    prepareSkipMenu();
    addCarets();
    prepareMenu();
    setBodyPadding();
    makeSticky();

    $(window).resize(() => {
        prepareMenu();
        $('[data-header-wrap]').on(
            'transitionend',
            () => setBodyPadding()
        );
    });
};

export default {
    initialize,
};

